<template>
    <div
        class="flex justify-center"
        data-spec-id="configurator-form--cloud"
    >
        <ConfirmationForm
            :type="AssortmentType.Cloud"
            class="w-full lg:w-2/3 xl:w-1/2"
            price="0"
            configuration=""
            url-modifier="/confirm"
            redirect-params="?redirect=cloud-server"
            :is-usable-for-user="true"
        />
    </div>
</template>

<script setup>
import ConfirmationForm from './ConfirmationForm.vue';
import { AssortmentType } from '../../../types';
</script>
